<template>
  <div class="w98">
   <div class="crumb">
      <span><router-link to="/Help">帮助</router-link>  > </span>
      <span>音视频</span>
    </div>
     <help-Menu></help-Menu>
    <div class="rightContent">
      <div class="conten">
        <p class="text">在进行每日读片、专题读片及学习课程的过程中，可开启音视频互动。</p>
        <P class="text">中间为视频展示区域，点击【病案共享模式】/【视频会诊模式】可切换视频大小，病案共享模式可进行屏幕区域共享或文档共享。</P>
        <P class="text">左侧上方为参会人员展示区域，可看到当前加入会议的成员，并设置是否需要使用摄像头和麦克风。</P>
        <P class="text">左侧下方为公共聊天区域，主持人可在此与其他人互动。</P>
        <div><img  style="width:89%" src="../../../../static/image/89.png"/></div>
        <P class="text">点击【直播/录播】-【开始点播录制】生成一个直播地址及直播二维码，可通过手机扫一扫观看直播。</P>
        <P class="text">点击【直播/录播】-【停止直播】直播视频录制完成，生成一个录播地址及录播视频二维码，可通过手机扫一扫观看已经录制的直播视频。见下图。</P>
         <div>
           <img src="../../../../static/image/90.png"/>
           <img src="../../../../static/image/91.png"/>
         </div>
        <P class="text">视频客户端需提前下载，若没下载，点击教学右上角【视频客户端下载】即可。</P>
      </div>
    </div>
</div>
</template>

<script type="text/ecmascript-6">
  import {getRightHeight} from '@/common/js/rightHeight'
  import helpHead from '@/components/common/header/helpHead'
  import helpMenu from '@/components/common/helpMenu/helpMenu'
  export default {
    data () {
      return {
         height:''
      }
    },
    components:{
        helpHead,
        helpMenu
    },
      mounted() {
      setTimeout(() => {
//        this._getRightW()
        getRightHeight('rightContent', this.height)
      }, 20)
      window.addEventListener('resize', () => {
//        this._getRightW()
        getRightHeight('rightContent', this.height)
      })
    },
}

</script>


<style scoped lang="stylus" rel="stylesheet/stylus">
.content
    min-width: 100vw
    height: 100vh
    overflow: hidden
.rightContent
    position: relative
    float: right
    height :calc(100vh - 80px)
    width: calc(80% - 1px)
    min-width: 919px
    background :#fff
    overflow:auto
   .conten
      padding: 25px 25px 25px 30px

   .littleImg
      width:30px
      vertical-align:middle
   .text
     color:#555
     line-height: 25px

  .crumb
   line-height: 30px
   margin: 5px 0 0 20px

</style>



// WEBPACK FOOTER //
// Audio.vue?4b2d48ae